import { render, staticRenderFns } from "./assignedTrainingsToAdvisor.vue?vue&type=template&id=be42348c"
import script from "./assignedTrainingsToAdvisor.vue?vue&type=script&lang=js"
export * from "./assignedTrainingsToAdvisor.vue?vue&type=script&lang=js"
import style0 from "./assignedTrainingsToAdvisor.vue?vue&type=style&index=0&id=be42348c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports